import React from "react";
import AboutContent from "../Components/AboutContent";

const About = () => {
  return (
    <div>
      <AboutContent />
    </div>
  );
};

export default About;
